<template>
	<div class="wrapper form">
		<div class="input-wrapper">
			<div class="input__title">Biztosított adatai:</div>
			<InputField :elements="fields.contractDetails" />
		</div>
        <div class="input-wrapper no-p-top">
            <CalcElem
                name="differentInsuredPermanentAddress"
                :options="{
					label: 'A biztosított állandó lakcíme eltér a kockázatviselési címtől',
					type: 'checkbox',
					wrapperClass: 'col-w100-chbox chbox_style-wrapper',
					className: 'mw-500px',
					prop: 'differentInsuredPermanentAddress',
				}"
                type="contracting"
                class="checkbox-center"
            />
        </div>
		<div class="input-wrapper" v-if="getCheckboxData('differentInsuredPermanentAddress')">
			<div class="input__title">Biztosított állandó lakcíme:</div>
			<InputField :elements="fields.permanentAddress" refGroup="insuredData-permanentAddress" />
		</div>
		<div class="input-wrapper no-p-top">
			<CalcElem
				name="differentInsuredMailingAddress"
				:options="{
					label: 'Levelezési cím eltér a fentiektől',
					type: 'checkbox',
					wrapperClass: 'col-w100-chbox chbox_style-wrapper',
					className: 'mw-500px',
					prop: 'differentInsuredMailingAddress',
				}"
				type="contracting"
				class="checkbox-center"
			/>
		</div>
		<div
			class="input-wrapper mb-20px"
			style="background-color: #f4f5f4"
			v-if="getCheckboxData('differentInsuredMailingAddress')"
		>
			<div class="input__title">Biztosított levelezési címe:</div>
			<InputField :elements="fields.mailingAddress" refGroup="insuredData-mailingAddress" />
		</div>
	</div>
</template>

<script>
import _ from 'lodash';
import dataPages from '@/mixins/dataPages';
import insuredData from '@/mixins/insuredData';

export default {
	mixins: [dataPages, insuredData],
	data() {
		return {
			insurer: 'union',
			type: 'insuredData',
		};
	},
};
</script>
